
import { ChildType } from '../types/interface';
const childValueTyleOptions = [{
    value: String(ChildType.EngineValue),
    label: '工程值'
}, {
    value: String(ChildType.Statistics),
    label: '统计值'
}];

const periodOptions = [{
    value: 'everyMonth',
    label: '每月'
}, {
    value: 'everyDay',
    label: '每天'
}];

const aggregateOptions = [{
    value: 'sum',
    label: 'sum'
}, {
    value: 'average',
    label: 'average'
}, {
    value: 'max',
    label: 'max'
}, {
    value: 'min',
    label: 'min'
}];

// 周期聚合
const periodAggregateOption = [{
    value: 'day-max',
    label: '每天-max'
}, {
    value: 'month-average',
    label: '每月-平均值'
}];
export default {
    childValueTyleOptions,
    periodOptions,
    aggregateOptions,
    periodAggregateOption,
}